import React, { createContext, useEffect, useState } from "react";
import { useDeviceType } from "@UI/hooks/useDeviceType";
import { IEventMetadata, setMetadataHeaders } from "../services/events";

export const MetadataContext = createContext<{
  metadata?: Partial<IEventMetadata>;
  setMetadata?: (metadata: Partial<IEventMetadata>) => void;
}>({});

export const MetadataProvider = ({ children }) => {
  const [metadata, setStateMetadata] = useState<Partial<IEventMetadata>>({
    system: "web",
  });
  const deviceType = useDeviceType();

  useEffect(() => {
    setMetadataHeaders(metadata);
  }, [metadata]);

  useEffect(() => {
    if (!deviceType) return;

    setStateMetadata((prev) => ({
      ...prev,
      deviceType,
    }));
  }, [deviceType]);

  const setMetadata = (metadata: Partial<IEventMetadata>) => {
    setStateMetadata((prev) => ({
      ...prev,
      ...metadata,
    }));
  };

  return (
    <MetadataContext.Provider value={{ setMetadata, metadata }}>
      {children}
    </MetadataContext.Provider>
  );
};
